import { useEffect, useState } from "react"
import { AnimatePresence } from "framer-motion"
import { DashboardContainer, Header, Title, ContentArea } from "../components/Dash/styled/Layout"
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from "react-router-dom"
import { useProductos } from "../hooks/useProductos"
import { useSnackbar } from "notistack"
import FormEdit from "../components/FormEdit"
import { Toaster } from 'react-hot-toast';


export default function Dashboard() {
  const { productos, formatoCOP, ordenes, getOrdenes, deleteProducto } = useProductos();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getOrdenes();
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        when: "beforeChildren",
      },
    },
  }

  const headerVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  }

  useEffect(() => {
    if (productos && Array.isArray(productos)) {
      setProducts(productos);
    }
  }, [productos]);

  console.log(products)

  const handleAddProduct = () => {
    const newProduct = {
      id: (products.length + 1).toString(),
      name: "Nuevo Producto",
      sku: `SKU-${products.length + 1}`,
      inventory: 0,
      price: 0,
      category: "Sin categoría",
      colors: ["#000000"],
      date: new Date().toISOString().split("T")[0],
    }
    setProducts([...products, newProduct])
  }

  const handleEditProduct = (editedProduct) => {
    setProducts(productos.map((product) => (product.id === editedProduct.id ? editedProduct : product)))
    setEditingProduct(null)
  }

  const handleDeleteProduct = (productId) => {
    setProducts(products.filter((product) => product.id !== productId));

    deleteProducto(productId).then((data) => {
      enqueueSnackbar('Producto eliminado con exito.', { variant: 'success', anchorOrigin: { vertical: 'bottom', horizontal: 'right' } });
    }).catch((error) => {
      console.log(error);
    })

  }

  const openEditModal = (product) => {
    setEditingProduct(product)
  }

  return (
    <DashboardContainer initial="hidden" animate="visible" variants={containerVariants}>
      <Toaster/>
      <Header variants={headerVariants}>
        <Title>Administración</Title>

        <LogoutIcon style={{ cursor: "pointer" }} onClick={() => navigate("/")} />

      </Header>
      <ContentArea>

        <AnimatePresence mode="wait">
           <FormEdit create={false}/>
        </AnimatePresence>
      </ContentArea>
    </DashboardContainer>

  )
}


